export const STATUS = [
  {
    value: 'semua',
    label: 'Semua',
  },
  {
    value: 'negeri',
    label: 'Negeri',
  },
  {
    value: 'swasta',
    label: 'Swasta',
  },
]

export const MAP_STATUS_BY_NAME = {
  semua: 'EDUCATION_STATUS_UNSPECIFIED',
  negeri: 'EDUCATION_STATUS_NEGERI',
  swasta: 'EDUCATION_STATUS_SWASTA',
}

export const MAP_STATUS_BY_VALUE = {
  EDUCATION_STATUS_UNSPECIFIED: 'Semua',
  EDUCATION_STATUS_NEGERI: 'Negeri',
  EDUCATION_STATUS_SWASTA: 'Swasta',
}

export const MAP_STATUS_BY_VALUE_FOR_HEADING = {
  EDUCATION_STATUS_UNSPECIFIED: 'Negeri/Swasta',
  EDUCATION_STATUS_NEGERI: 'Negeri',
  EDUCATION_STATUS_SWASTA: 'Swasta',
}
